import cc, { CurrencyCodeRecord } from 'currency-codes';
import { IntlShape } from 'react-intl';

const getCurrencyInfo = (currency: string): CurrencyCodeRecord => {
  const currencyInfo = cc.code(currency);
  if (!currencyInfo) {
    throw new Error('Currency is not supported!');
  }
  return currencyInfo;
};

export const convertFromCents = (value: number, currency: string) => {
  const currencyInfo = getCurrencyInfo(currency);
  const divider = Math.pow(10, currencyInfo.digits);
  return value / divider;
};

export const convertToCents = (value: number, currency: string) => {
  const currencyInfo = getCurrencyInfo(currency);
  const multiplier = Math.pow(10, currencyInfo.digits);
  return Math.round(value * multiplier);
};

export const getCurrencySymbol = (intl: IntlShape, currency: string) => {
  return intl
    .formatNumber(0, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace('0', '');
};
